import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import styled from 'foundations-theming/utils';
import { useMedia } from 'pricing-pages-ui-components/hooks/useMedia';
import { useId } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TermOption = ({
  children,
  name,
  selected,
  'data-value': dataValue
}) => {
  const labelId = useId();
  const isCs = useMedia('cs');
  return /*#__PURE__*/_jsxs(Flex, {
    inlineSize: "50%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: isCs ? '100' : '200',
    zIndex: 2,
    id: labelId,
    "aria-checked": selected,
    "data-value": dataValue,
    children: [/*#__PURE__*/_jsx(ScreenReaderOnly, {
      children: /*#__PURE__*/_jsx(RadioInput, {
        checked: selected,
        "aria-checked": selected,
        "aria-labelledby": labelId,
        name: name
      })
    }), children]
  });
};
const PaymentLabel = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Text, {
    color: "text-core-default",
    typography: "heading-25",
    textAlign: "center",
    as: "div",
    children: children
  });
};
const SelectedTerm = styled.div.withConfig({
  displayName: "BaseTermSelectorComponent__SelectedTerm"
})(({
  theme,
  activeTerm
}) => {
  return {
    position: 'absolute',
    insetBlock: '-1px',
    insetInlineStart: activeTerm === 'MONTHLY' ? '-1px' : 'calc(50% - 1px)',
    inlineSize: 'calc(50% + 2px)',
    background: theme.color['fill-surface-default'],
    borderRadius: theme.borderRadius['300'],
    borderWidth: theme.borderWidth[100],
    borderStyle: 'solid',
    borderColor: theme.color['border-core-default'],
    transition: 'all 0.2s ease-in-out'
  };
});
export const BaseTermSelectorComponent = ({
  onToggleChange,
  dataSeleniumId,
  activeTerm,
  availableTerms
}) => {
  const radioGroupId = useId();
  if (!(availableTerms !== null && availableTerms !== void 0 && availableTerms.annual) || !(availableTerms !== null && availableTerms !== void 0 && availableTerms.monthly)) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    cursor: "pointer",
    backgroundColor: "fill-surface-recessed",
    borderWidth: "100",
    borderStyle: "solid",
    borderColor: "border-core-default",
    inlineSize: "100%",
    blockSize: "100%",
    position: "relative",
    borderRadius: "300",
    onClick: onToggleChange,
    "data-selenium-id": dataSeleniumId,
    children: /*#__PURE__*/_jsxs(Flex, {
      as: "fieldset",
      justifyContent: "space-between",
      blockSize: "100%",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsxs(TermOption, {
        selected: activeTerm === 'MONTHLY',
        name: radioGroupId,
        "data-value": 'MONTHLY',
        children: [/*#__PURE__*/_jsx(PaymentLabel, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.detailedTermSelector.payMonthly"
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "div",
          typography: "detail-100",
          textAlign: "center",
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: availableTerms.monthly.commitment === 'ANNUAL' ? 'pricingPage.detailedTermSelector.commitAnnually' : 'pricingPage.detailedTermSelector.commitMonthly'
          })
        })]
      }), /*#__PURE__*/_jsx(TermOption, {
        selected: activeTerm === 'ANNUAL',
        name: radioGroupId,
        "data-value": 'ANNUAL',
        children: /*#__PURE__*/_jsxs(PaymentLabel, {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "div",
            typography: "heading-25",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: availableTerms.annual.payment === 'ANNUAL' ? 'pricingPage.detailedTermSelector.payAnnually' : 'pricingPage.detailedTermSelector.payMonthly'
            })
          }), /*#__PURE__*/_jsx(Text, {
            as: "span",
            textTransform: "uppercase",
            color: "text-core-subtle",
            typography: "heading-25",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.detailedTermSelector.bestValue"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(SelectedTerm, {
        activeTerm: activeTerm
      })]
    })
  });
};